
<template>
    <div class="component">
        <ul class="progressbar">
            <li v-bind:class="propertyStepStyle">{{ stepOneLabel }}
                <div class="bar">
                    <div v-bind:class="propertyProgressStyle"></div>
                </div>
            </li>
            <li v-bind:class="sellerStepStyle">About You
                <div class="bar">
                    <div v-bind:class="sellerProgressStyle"></div>
                </div>
            </li>
            <li v-if="this.type !== 'cash'" v-bind:class="yourAgentStepStyle">Your Ideal Agent</li>
            <li v-if="this.type === 'cash'" v-bind:class="yourAgentStepStyle">Finished</li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'ProgressBar',
        props: ['value', 'type', 'steps'],
        data() {
            return {}
        },
        computed: {
            propertyStepStyle: function () {
                switch (this.value) {
                    case 'address':
                        return 'active';
                    case 'propertyType':
                        return 'active';
                    case 'price':
                        return 'active';
                    case 'timeFrame':
                        return 'active';
                    case 'buyQuestion':
                        return 'active';
                    case 'visitorInfo':
                        return 'done';
                    case 'agentIntroduction':
                        return 'done';
                    default:
                        return null;
                }
            },
            propertyProgressStyle: function () {
                switch (this.value) {
                    case 'address':
                        return 'active-bar active-bar-width-20';
                    case 'propertyType':
                        return 'active-bar active-bar-width-30';
                    case 'price':
                        return 'active-bar active-bar-width-40';
                    case 'timeFrame':
                        return 'active-bar active-bar-width-50';
                    case 'buyQuestion':
                        return 'active-bar active-bar-width-60';
                    case 'visitorInfo':
                        return 'full-bar';
                    case 'agentIntroduction':
                        return 'full-bar';
                    default:
                        return 'active-bar active-bar-width-1';
                }
            },
            sellerStepStyle: function () {
                switch (this.value) {
                    case 'visitorInfo':
                        return 'active';
                    case 'agentIntroduction':
                        return 'done';
                    default:
                        return null;
                }
            },
            sellerProgressStyle: function () {
                switch (this.value) {
                    case 'visitorInfo':
                        return 'active-bar active-bar-width-60';
                    case 'agentIntroduction':
                        return 'active-bar active-bar-width-100';
                    default:
                        return 'zero-bar';
                }
            },
            yourAgentStepStyle: function (){
                let currentStep = this.value;
                if (currentStep === 'agentIntroduction'){
                    return 'done';
                }
                return null;
            },
            isPropertyStep: function (name) {
                const nonPropertySteps = ['agentIntroduction', 'visitorInfo', 'buyQuestion']
                return nonPropertySteps.indexOf(name) < 0
            },
            stepOneLabel: function() {
                return this.type === 'buy' ? 'Buy Location' : 'Your Property';
            },
        }
    }
</script>

<style scoped>
    .progressbar {
        counter-reset: step;
    }

    ul {
        padding: 0;
    }

    .progressbar li {
        list-style-type: none;
        float: left;
        width: 33%;
        position: relative;
        text-align: center;
    }

    .progressbar li::before {
        counter-increment: step;
        content: counter(step);
        width: 45px;
        height: 45px;
        line-height: 40px;
        border: 3px solid #ddd;
        display: block;
        text-align: center;
        margin: 0 auto 10px auto;
        border-radius: 50%;
        background-color: white;
        font-weight: bold;
    }

    .bar {
        min-height: 4px;
        background-color: #ddd;
        width: 100%;
        position: absolute;
        top: 20px;
        left: 50%;
        z-index: -1;
    }

    .active-bar {
        min-height: 4px;
        background-color: #003366;
        width: 1%;
        transition: width 1s;
    }

    .active-bar-width-1 {
        width: 1%;
        transition: width 1s;
    }

    .active-bar-width-20 {
        width: 20%;
        transition: width 1s;
    }

    .active-bar-width-40 {
        width: 40%;
        transition: width 1s;
    }

    .active-bar-width-60 {
        width: 60%;
        transition: width 1s;
    }

    .active-bar-width-80 {
        width: 80%;
        transition: width 1s;
    }

    .active-bar-width-90 {
        width: 90%;
        transition: width 1s;
    }
    .active-bar-width-100 {
        width: 100%;
        transition: width 1s;
    }

    .progressbar li:first-child::after {
        content: none;
    }

    .progressbar li.active::before {
        color: #ffffff;
        border-color: #003366;
        background-color: #00b4ef;
        transition-delay: .75s;
    }

    .progressbar li.done::before {
        content: '';
        border-color: #003366;
        background-color: #b3efb3;
        background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='%23008000' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M13.854 3.646a.5.5 0 010 .708l-7 7a.5.5 0 01-.708 0l-3.5-3.5a.5.5 0 11.708-.708L6.5 10.293l6.646-6.647a.5.5 0 01.708 0z'/></svg>");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: 2rem 2rem;
    }

    .full-bar {
        width:100%;
        min-height: 4px;
        background-color: #003366;
    }
    .zero-bar {
        width:0%;
    }

</style>
